import RoomArcade from './RoomArcade.vue';
import TetrisGame from './Tetris/TetrisGame.vue';
import RoomArcadeEdit from './RoomArcadeEdit.vue';
export default RoomArcade;
export { RoomArcadeEdit, TetrisGame };
